import {useMutation, useQueryClient} from "@tanstack/react-query";
import {QUERY_KEYS} from "infra/libs/react-query/queryKeys";
import {PatchFavoritePlaceServiceParams} from "../types";
import {patchFavoritePlace} from "../services/patchFavoritePlace";

export function usePatchFavoritePlaceMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({cdBeneficiarioEnderecoFavorito, data, signal}: PatchFavoritePlaceServiceParams) => 
      patchFavoritePlace({cdBeneficiarioEnderecoFavorito, data, signal}),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [QUERY_KEYS.HEALTH_GUIDE_FAVORITE_PLACES]});
    },
  });
}
